import { IsString, MaxLength, IsOptional, IsInt, IsISO8601 } from 'class-validator';

export class NotificationHistorySearchDTO {

    @IsOptional()
    @MaxLength(50)
    body: string;

    @IsOptional()
    @IsInt()
    entity: number;

    @IsOptional()
    @IsInt()
    event: number;

    @IsOptional()
    @IsInt()
    type: number;

    @IsOptional()
    @IsISO8601()
    from: string;

    @IsOptional()
    @IsISO8601()
    to: string;

}
